import React, { useState, useEffect } from 'react';
import { Box, Typography } from "@mui/material";
import { Doughnut } from 'react-chartjs-2';
import { makeStyles } from "@material-ui/core/styles";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import ChartDialog from "./ChartDialog";
import Skeleton from "@mui/material/Skeleton";

ChartJS.register(ArcElement, Tooltip, Legend);

const useStyles = makeStyles((theme) => ({
    chartContainer: {
        backgroundColor: 'rgba(255, 255, 255, 1)',
        borderRadius: '9px',
        padding: theme.spacing(2),
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
    },
    doughnutChartContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        marginBottom: theme.spacing(2),
        width: '100%',
        height: '250px',
    },
    doughnutLegend: {
        display: 'flex',
        marginTop: theme.spacing(2),
        flexWrap: 'wrap',
        width: '100%',
    },
    legendItem: {
        margin: theme.spacing(0.5, 1),
        display: 'flex',
        alignItems: 'center',
    },
    legendColorBox: {
        borderRadius: '50%',
        width: 15,
        height: 15,
        marginRight: theme.spacing(0.5),
    },
    legendLabel: {
        fontSize: '12px',
        fontWeight: 500,
        fontFamily: 'Poppins',
        color: 'rgba(18, 18, 18, 1)',
    },
    filterContainer: {
        display: 'flex',
        marginBottom: theme.spacing(2),
    },
    dateContainer: {
        margin: theme.spacing(0, 1),
        borderColor: 'rgba(225, 231, 236, 1)',
        outline: 'none',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        fontFamily: 'Poppins',
        paddingLeft: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        padding: '5px 10px',
        '&::placeholder': {
            color: 'rgba(42, 46, 51, 1)',
        },
    },
}));

const ClaimsByManagementType = (props) => {
    const classes = useStyles();

    const { claimData, loading, disableClick } = props;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedManagementType, setSelectedManagementType] =
        useState(null);

    const managementMap = (claimData || []).reduce((acc, item) => {
        acc[item.managementType] = item.count;
        return acc;
    }, {});

    const doughnutData = {
        labels: Object.keys(managementMap),
        datasets: [
            {
                data: Object.values(managementMap),
                backgroundColor: [
                    'rgba(240, 243, 199, 1)',
                    'rgba(60, 101, 86, 1)',
                    'rgba(187, 200, 8, 1)',
                ],
            },
        ],
    };

    const handleClick = (event, elements) => {
        if (disableClick || loading) return;

        if (elements.length > 0) {
            const index = elements[0].index;
            const label = doughnutData.labels[index];
            setSelectedManagementType(label);
            setDialogOpen(true);
        }
    };

    return (
        <Box className={classes.chartContainer}>
            <Typography
                style={{
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    marginBottom: '10px',
                }}
            >
                Suivi Sinistres par mode de gestion
            </Typography>

            <Box className={classes.doughnutChartContainer}>
                {loading ? (
                    <Skeleton
                        variant="circular"
                        width={180}
                        height={180}
                        animation="wave"
                    />
                ) : (
                    <Doughnut
                        data={doughnutData}
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            cutout: '70%',
                            plugins: { legend: { display: false } },
                            onClick: handleClick,
                        }}
                    />
                )}
            </Box>

            <ChartDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                managementTypeClaimsByManagementType={
                    selectedManagementType
                }
            />
        </Box>
    );
};



export default ClaimsByManagementType;
